import Create from '@/views/products/Create'
import CreateStep1 from '@/views/products/create/Step1'
import CreateStep2 from '@/views/products/create/Step2'
import CreateStep3ForPurchaser from '@/views/products/create/Step3ForPurchaser'
import CreateStep3ForZmuekish from '@/views/products/create/Step3ForZmuekish'
import CreateStep4 from '@/views/products/create/Step4'
import CreateStep5 from '@/views/products/create/Step5'
import Index from '@/views/products/Index'
import TemplatesIndex from '@/views/products/templates/Index'
import ViewForMediaProduction from '@/views/products/ViewForMediaProduction'
import ViewForPurchaser from '@/views/products/ViewForPurchaser'
import ViewAddresses from '@/views/products/view/Addresses'
import ViewFiles from '@/views/products/view/Files'
import ViewOffers from '@/views/products/view/Offers'
import ViewPrices from '@/views/products/view/Prices'
import ProductionsCosts from '@/views/products/view/ProductionsCosts'
import ViewQualityRating from '@/views/products/view/QualityRating'
import ViewDocuments from '@/views/products/view/Documents'

import Vue from 'vue'

export default [
    {
        path: '/products/create',
        component: Create,
        meta: { title: 'Produkt anlegen' },
        children: [{
            path: '',
            name: 'products/create',
            component: CreateStep1
        },{
            path: ':key',
            name: 'products/create/step1',
            component: CreateStep1
        }, {
            path: ':key/2',
            name: 'products/create/step2',
            component: CreateStep2
        }, {
            path: ':key/3',
            name: 'products/create/step3',
            component() {
                if (Vue.$auth.isZmuekish) {
                    return Promise.resolve(CreateStep3ForZmuekish)
                } else {
                    return Promise.resolve(CreateStep3ForPurchaser)
                }
            }
        }, {
            path: ':key/4',
            name: 'products/create/step4',
            component: CreateStep4
        }, {
            path: ':key/5',
            name: 'products/create/step5',
            component: CreateStep5
        }]
    },
    {
        path: '/products',
        name: 'products',
        component: Index,
        meta: { title: 'Produkte' }
    },
    {
        path: '/products/index',
        redirect: '/products'
    },
    {
        path: '/products/templates',
        name: 'products/templates',
        component: TemplatesIndex,
        meta: { title: 'Vorlagen' }
    },
    {
        path: '/products/:id/variants/:variantId',
        query: { filter: 'OPEN' },
        name: 'products/view',
        component() {
            if (Vue.$auth.isZmuekish) {
                return Promise.resolve(ViewForMediaProduction)
            } else {
                return Promise.resolve(ViewForPurchaser)
            }
        },
        meta: { hideNavigation: false, title: (route, store) => store.getters['products/byId'](Number(route.params.id))?.name || 'Produkt' },
        children: [{
            path: 'addresses',
            name: 'productAddresses',
            component: ViewAddresses,
            meta: { hideNavigation: false, variantNavigationPosition: 'BOTTOM', title: 'Adressen' },
        }, {
            path: 'files',
            name: 'files',
            component: ViewFiles,
            meta: { hideNavigation: false, variantNavigationPosition: 'BOTTOM', title: 'Uploads' }
        }, {
            path: 'offers',
            name: 'offers',
            component: ViewOffers,
            meta: { hideNavigation: false, title: 'Preisangebote' },
        }, {
            path: 'prices',
            name: 'prices',
            component: ViewPrices,
            meta: { hideNavigation: false, title: 'Preisübersicht' },
        }, {
            path: 'production-costs',
            name: 'production-costs',
            component: ProductionsCosts,
            meta: { hideNavigation: false, variantNavigationPosition: 'BOTTOM', title: 'Produktionskosten' },
        }, {
            path: 'quality-rating',
            name: 'quality-rating',
            component: ViewQualityRating,
            meta: { hideNavigation: false, variantNavigationPosition: 'BOTTOM', title: 'Qualitätssicherung' },
        }, {
            path: 'documents',
            name: 'documents',
            component: ViewDocuments,
            meta: { hideNavigation: false, variantNavigationPosition: 'BOTTOM', title: 'Dokumente' },
        }]
    }
]

